import React, { SyntheticEvent } from "react";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import { Autocomplete, TextField } from "@mui/material";
import { RootState } from "../../app/store";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { updateSelectedPrompt, tones } from "../../app/promptsSlice";

function ToneFormControl() {
  const dispatch = useAppDispatch();
  const tone = useAppSelector(
    (state: RootState) => state.prompts.selectedPrompt.tone
  );

  const handleSelectChange = (
    event: SyntheticEvent<Element, Event>,
    newTones: string[] | null
  ) => {
    dispatch(updateSelectedPrompt({ tone: newTones }));
  };

  return (
    <Grid container spacing={2}>
      <FormControl fullWidth>
        <Autocomplete
          id="tone-textfield"
          multiple
          options={tones.map((tone) => tone.name)}
          onChange={handleSelectChange}
          value={tone}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              label="Tone"
              placeholder={
                !tone || tone.length > 0
                  ? undefined
                  : "e.g. Authoritative, Optimistic, Provocative"
              }
              helperText="Shape the tone of the output"
            />
          )}
        />
      </FormControl>
    </Grid>
  );
}

export default ToneFormControl;
